import { FeedbackBlockKind } from "@spscommerce/ds-shared";
import * as React from "react";

import { SpsCard, SpsFeedbackBlock } from "../index";

export class SpsFeedbackBlockTip extends React.Component<{ "data-testid": any }> {
    // A demo-able representation of this example
    static testId = "sps-feedback-block-tip";
    static reactLive = {
        code: `
            <SpsCard>
                <SpsFeedbackBlock>
                    Click the Receive button above to check for new transactions from QuickBooks.
                </SpsFeedbackBlock>
            </SpsCard>
        `
    };

    render() {
        const { "data-testid": testId } = this.props;
        return (
            <SpsCard>
                <SpsFeedbackBlock data-testid={testId}>
                    Click the Receive button above to check for new transactions from QuickBooks.
                </SpsFeedbackBlock>
            </SpsCard>
        );
    }
}

export class SpsFeedbackBlockInfo extends React.Component<{ "data-testid": any }> {
    // A demo-able representation of this example
    static testId = "sps-feedback-block-info";
    static reactLive = {
        code: `
            <SpsCard>
                <SpsFeedbackBlock kind="info">
                    FYI â This page has been updated. <a href="">Click refresh</a> to see the most recent version.
                </SpsFeedbackBlock>
            </SpsCard>
        `
    };

    render() {
        const { "data-testid": testId } = this.props;
        return (
            <SpsCard>
                <SpsFeedbackBlock kind={FeedbackBlockKind.INFO} data-testid={testId}>
                    FYI â This page has been updated. <a href="">Click refresh</a> to see the most recent version.
                </SpsFeedbackBlock>
            </SpsCard>
        );
    }
}

export class SpsFeedbackBlockSuccess extends React.Component<{ "data-testid": any }> {
    // A demo-able representation of this example
    static testId = "sps-feedback-block-success";
    static reactLive = {
        code: `
            <SpsCard>
                <SpsFeedbackBlock kind="success">
                    All items have been uploaded and are <span style={{fontWeight:600}}>ready for export.</span>
                </SpsFeedbackBlock>
            </SpsCard>
        `
    };

    render() {
        const { "data-testid": testId } = this.props;
        return (
            <SpsCard>
                <SpsFeedbackBlock kind={FeedbackBlockKind.SUCCESS} data-testid={testId}>
                    All items have been uploaded and are <span style={{ fontWeight: 600 }}>ready for export.</span>
                </SpsFeedbackBlock>
            </SpsCard>
        );
    }
}

export class SpsFeedbackBlockWarning extends React.Component<{ "data-testid": any }> {
    // A demo-able representation of this example
    static testId = "sps-feedback-block-warning";
    static reactLive = {
        code: `
            <SpsCard>
                <SpsFeedbackBlock kind="warning">
                    Warning! This order is missing a shipment date and is in jeopardy of being past due.
                </SpsFeedbackBlock>
            </SpsCard>
        `
    };

    render() {
        const { "data-testid": testId } = this.props;
        return (
            <SpsCard>
                <SpsFeedbackBlock kind={FeedbackBlockKind.WARNING} data-testid={testId}>
                    Warning! This order is missing a shipment date and is in jeopardy of being past due.
                </SpsFeedbackBlock>
            </SpsCard>
        );
    }
}

export class SpsFeedbackBlockError extends React.Component<{ "data-testid": any }> {
    // A demo-able representation of this example
    static testId = "sps-feedback-block-error";
    static reactLive = {
        code: `
            <SpsCard>
                <SpsFeedbackBlock kind="error">
                    We are experiencing difficulties communicating to the server. Please try again later.
                </SpsFeedbackBlock>
            </SpsCard>
        `
    };

    render() {
        const { "data-testid": testId } = this.props;
        return (
            <SpsCard>
                <SpsFeedbackBlock kind={FeedbackBlockKind.ERROR} data-testid={testId}>
                    We are experiencing difficulties communicating to the server. Please try again later.
                </SpsFeedbackBlock>
            </SpsCard>
        );
    }
}